<template>
    <grid :columns="gridColumns"
          :provider="provider"
          :show-column-options="!redemptionCode"
          @completed="stopLoadingPage">
        <slot v-if="$slots.title" name="title" slot="title"/>
        <slot v-if="$slots['no-content']" name="no-content" slot="no-content"/>
    </grid>
</template>

<script>
    import Grid from '@/components/grid/grid';
    import ColumnSet from '@/components/grid/columns/column-set';
    import LoadStateMixin from '@/mixins/load-state-mixin';
    import store from '@/store';
    import {createDialog, vConfirm} from '@/components/modal/dialogs';

    export default {
        name: 'redemption-grid',
        mixins: [LoadStateMixin],
        components: {Grid},
        props: {
            redemptionCode: String,
            title: String,
        },
        data() {
            return {
                baseDefinition: {
                    defaultColumns: [
                        {
                            name: 'redemptionCode',
                            type: 'link',
                            style: {truncate: true},
                            to: ({fields}) => {
                                if (this.$auth.$pages['coupon-details'].isAllowed) {
                                    return {
                                        name: 'coupon-details',
                                        params: {
                                            id: fields.redemptionCode,
                                        },
                                    };
                                }
                                return null;
                            },
                            sortable: true,
                            sticky: true,
                        },
                        {
                            name: 'customerId',
                            type: 'link',
                            style: {truncate: true},
                            to: ({fields}) => {
                                if (this.$auth.$pages['customer-details'].isAllowed) {
                                    return {
                                        name: 'customer-details',
                                        params: {
                                            id: fields.customerId,
                                        },
                                    };
                                }
                                return null;
                            },
                            sortable: true,
                        },
                        {
                            name: 'redeemedTime',
                            type: 'datetime',
                            sortable: true,
                        },
                        {
                            name: 'canceledTime',
                            type: 'datetime',
                            sortable: true,
                        },
                    ],
                    lockedColumns: [
                        {
                            header: 'Cancel Redemption',
                            type: 'button',
                            style: {
                                label: 'Cancel',
                            },
                            isDisabled: ({rowData}) => !!rowData.fields.canceledTime,
                            click: ({rowData, grid}) => {
                                if (this.$auth.$pages['coupons-redemptions'].isAllowed) {
                                    this.showCancelRedemptionDialog(rowData, grid);
                                }
                            },
                        },
                    ],

                },

            };
        },
        computed: {
            gridCouponsRedemptionsColumns() {
                return new ColumnSet({
                    id: 'coupons-redemptions-list',
                    store,
                    version: 3,
                    ...this.baseDefinition,
                });
            },
            gridCouponRedemptionsColumns() {
                return new ColumnSet({
                    id: 'coupon-redemptions-list',
                    store,
                    version: 3,
                    defaultColumns: this.baseDefinition.defaultColumns.slice(1),
                    lockedColumns: this.baseDefinition.lockedColumns,
                });
            },
            gridColumns() {
                return this.redemptionCode
                    ? this.gridCouponRedemptionsColumns : this.gridCouponsRedemptionsColumns;
            },
        },
        methods: {
            async showCancelRedemptionDialog({fields}, grid) {
                const confirmDialog = createDialog(vConfirm, this);
                const dialogParams = {
                    title: 'Cancel Redemption',
                    content: 'Are you sure you want to cancel this redemption?',
                    confirmLabel: 'Cancel Redemption',
                    dangerConfirm: true,
                };
                if (await confirmDialog(dialogParams)) {
                    this.cancelRedemption(fields, grid);
                }
            },
            async cancelRedemption({id}, grid) {
                try {
                    const params = {id};
                    grid.startLoading();
                    await this.$api(({coupons}) => coupons.cancelRedemption(params));
                    grid.fetchData();
                    this.$toast.positive('Redemption successfully canceled');
                } catch (error) {
                    this.$toast.fromError(error);
                    grid.stopLoading();
                }
            },
            provider(params) {
                if (this.redemptionCode) {
                    params.filter = `redemptionCode:${this.redemptionCode}`;
                    params.expand = 'customer';
                }
                return this.$api(({coupons}) => coupons.getAllRedemptions(params));
            },
        },
    };
</script>
